<template>
  <FilterSingleChip
    icon="share-2"
    :is-text="isText"
    :label="$t('search-filters.action-filters.shared')"
    :items="items"
    :value="value && value.length ? value[0] : null"
    @change="onChange"
  />
</template>

<script>
import FilterSingleChip from '@/components/filters/FilterSingleChip';
import { SHARED_FILTERS_VALUES } from '@/models/search-filters';

/**
 * Shared dimension chip (shared / unshared). A single choice stored as an array (shareFilters) —
 * adapts array↔value around a single-select FilterSingleChip. Presentational: `:value` (array)
 * in, `change` (0/1 array) out.
 */
export default {
  name: 'SharedChip',
  components: { FilterSingleChip },
  props: {
    value: { type: Array, default: () => [] },
    // Show the dimension name on the chip face (used in the compact stacked filters dialog).
    isText: { type: Boolean, default: false },
  },
  computed: {
    items() {
      return SHARED_FILTERS_VALUES.map((value) => ({
        value,
        text: this.$t(`search-filters.action-filters.values.${value}`),
      }));
    },
  },
  methods: {
    onChange(next) {
      this.$emit('change', next == null ? [] : [next]);
    },
  },
};
</script>
